import { reduce } from 'underscore';
import { editorialRawErrorCodeToErrorMessageMapping } from './editorial-raw-error-code-mapping';

// mapping of editorial error code to reason message
export const editorialErrorCodeToReasonMessageMapping = reduce(editorialRawErrorCodeToErrorMessageMapping, (result, value, key) => {
  // eslint-disable-next-line no-param-reassign
  result[`EditorialReasons_${key}`] = value;
  return result;
}, {});
